<template>
    <div class="exam_login flex flexcolumn Flexalign Flexjustify">
        <div class="login_content">
            <div class="exam_name">{{ this.paperInfo.paperAppraisalName }}</div>
            <div class="login_box mt-20 p-30 flex flexcolumn Flexalign">
                <div class="login_top mt-20" :class="[step == 2 ? 'login_top_active' : '']">
                    <div class="step_1 flex Flexalign Flexjustify" :class="[step == 1 ? 'step_1_active' : '']">
                        <el-image class="device_check_white" :src="iconPath('device_check_white.png')"></el-image>
                        <div class="ml-10">设备检测</div>
                    </div>
                    <div class="step_1 step_2 flex Flexalign Flexjustify" :class="[step == 2 ? 'step_2_active' : '']">
                        <el-image class="device_check_white"
                            :src="iconPath(step == 1 ? 'identity_check_gray.png' : 'identity_check_white.png')"></el-image>
                        <div class="ml-10">身份验证</div>
                    </div>
                </div>
                <div class="login_info mt-30 flex flexcolumn Flexalign FlexEvenly">
                    <div class="login_label">请登录</div>
                    <div class="login_form flex Flexalign" v-if="showFormFields.name">
                        <div class="form_label">姓名：</div>
                        <el-input v-model="loginInfo.name" size="large" style="width: 280px" placeholder="姓名" />
                    </div>
                    <div class="login_form flex Flexalign" v-if="showFormFields.sex">
                        <div class="form_label">性别：</div>
                        <!-- <el-input v-model="loginInfo.code" size="large" style="width: 280px" placeholder="请输入验证码" /> -->
                        <el-radio-group v-model="loginInfo.sex" style="width: 280px;">
                            <el-radio value="男" size="large">男</el-radio>
                            <el-radio value="女" size="large">女</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="login_form flex Flexalign" v-if="showFormFields.grade">
                        <div class="form_label">年级：</div>
                        <el-select v-model="loginInfo.grade" placeholder="请选择当前所在年级" style="width: 280px" size="large">
                            <el-option v-for="item in gradeList" :key="item.gradeId" :label="item.gradeName"
                                :value="item.gradeId" />
                        </el-select>
                    </div>
                    <div class="login_form flex Flexalign" v-if="showFormFields.phone">
                        <div class="form_label">手机号：</div>
                        <el-input v-model="loginInfo.phone" @input="(e) => checkNumber(e, 'phone')" maxlength="11" size="large" style="width: 280px" placeholder="请输入手机号" />
                        <!-- <el-input v-model="loginInfo.phone" size="large" @input="(e) => checkNumber(e, 'phone')"
                            style="max-width: 280px; " placeholder="请输入手机号">
                            <template #append>
                                <div class="code_get cursor_pointer" @click="getCode" :style="[getActiveColor()]">
                                    {{ textCode }}
                                </div>
                            </template>
</el-input> -->
                    </div>
                    <!-- <div class="login_form flex Flexalign" v-if="isShowForm(1)">
                        <div class="form_label">验证码：</div>
                        <el-input v-model="loginInfo.code" size="large" style="width: 280px" placeholder="请输入验证码" />
                    </div> -->
                </div>
                <div class="btn cursor_pointer mt-50" @click="beginExam">登录开始考试</div>
                <div class="login_desc mt-10">手机号将用于接收您的能力分析报告，请确认无误后开启考试</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: 'GjkcH5ExamLogin',
    computed: {
        ...mapState({
            gradeList: (state) => state.filter.gradeList,
        }),
        // 添加计算属性
        showFormFields() {
            if (!this.paperInfo?.otherRule) return {};

            const studentInfo = JSON.parse(this.paperInfo.otherRule).studentInfo || [];
            return {
                name: studentInfo.includes(1),    // 1对应姓名
                sex: studentInfo.includes(2),     // 2对应性别
                grade: studentInfo.includes(3),   // 3对应年级
                phone: studentInfo.includes(4)    // 4对应手机号
            };
        }
    },
    data() {
        return {
            step: 2,
            loginInfo: {
                name: '',
                grade: '',
                phone: '',
                // code: '',
                sex: '',
                paperId:'',
                paperAppraisalId:'',
            },
            textCode: "获取验证码",
            paperInfo: {},
            paperType:'',
        };
    },
    mounted() {
        this.paperInfo = JSON.parse(this.$Jump.getUrlParams(window.location.hash.split("?")[1]).paperInfo);
        this.paperType = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).paperType;
    },
    methods: {
        checkNumber(value, type) {
            this.loginInfo[type] = value.replace(/[^0-9]/g, ""); // 移除非数字字符
        },
        getActiveColor() {
            if (this.loginInfo.phone) {
                return {
                    color: "#13d6aa",
                };
            }
        },
        // 获取验证码
        getCode() {
            if (this.$Tools.empty(this.loginInfo.phone)) {
                this.$Dialog.toast("手机号不能为空", { type: "error" });
                return;
            }
            if (!/^1[345678]\d{9}$/.test(this.loginInfo.phone)) {
                this.$Dialog.toast("请输入正确的手机号", { type: "error" });
                return;
            }
            if (this.disabled) return;
            this.disabled = true;
            let n = 60;
            this.textCode = "重新发送 " + n + "s";
            this.$Api.login.getCode({ phone: this.loginInfo.phone }).then((res) => {
                if (res.data.code == 200) {
                    this.$Dialog.toast("验证码已发送");
                    const run = setInterval(() => {
                        n = n - 1;
                        if (n < 0) {
                            clearInterval(run);
                        }
                        this.textCode = "重新发送 " + n + "s";
                        if (this.textCode < "重新发送 " + 0 + "s") {
                            this.disabled = false;
                            this.textCode = "重新获取";
                        }
                    }, 1000);
                }
            });
        },
        // 登录并考试
        beginExam() {
            if (this.showFormFields.name && !this.loginInfo.name?.trim()) {
                this.$Dialog.toast("请输入姓名", { type: 'warning' });
                return
            }

            if (this.showFormFields.sex && !this.loginInfo.sex) {
                this.$Dialog.toast("请选择性别", { type: 'warning' });
                return
            }

            if (this.showFormFields.grade && !this.loginInfo.grade) {
                this.$Dialog.toast("请选择年级", { type: 'warning' });
                return
            }

            if (this.showFormFields.phone) {
                if (!this.loginInfo.phone?.trim()) {
                    this.$Dialog.toast("请输入手机号", { type: 'warning' });
                    return
                } else if (!/^1[3456789]\d{9}$/.test(this.loginInfo.phone)) {
                    this.$Dialog.toast("请输入正确的手机号", { type: 'warning' });
                    return
                }
            }
            this.loginInfo.paperId = this.paperInfo.paperId;
            this.loginInfo.paperAppraisalId = this.paperInfo.paperAppraisalId;
            this.$Api.testPaper.collectUserInfo(this.loginInfo).then((res)=>{
                // 跳转至试卷页面
                this.href("/examPaper", { paperInfo: JSON.stringify(this.paperInfo),paperType:this.paperType,buyerUserId:res.data.data });
            }).catch(()=>{})
        }
    },
};
</script>

<style lang="scss" scoped>
.exam_login {
    width: 100%;
    height: 100vh;
    background: #f3f3f3;

    .login_content {
        width: $pageMainWidth;

        .exam_name {
            font-size: 18px;
            color: #606060;
            text-align: center;
        }

        .login_box {
            width: 1200px;
            height: 676px;
            background: #FFFFFF;
            box-shadow: 0px 7 30px 0px rgba(0, 0, 0, 0.14);
            border-radius: 10px;
            box-sizing: border-box;

            .login_top {
                width: 1070px;
                height: 63px;
                // background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
                background: #E6E6E6;
                border-radius: 10px;
                color: #FFFFFF;
                position: relative;

                .step_1 {
                    width: 535px;
                    height: 63px;
                    // background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
                    position: absolute;
                    left: 0;
                    border-radius: 10px;
                    color: #FFFFFF;

                    .device_check_white {
                        width: 22px;
                        height: 22px;
                    }
                }

                .step_1_active {
                    background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
                }

                .step_2 {
                    // background: #E6E6E6;
                    color: #606060;
                    left: 535px;
                    right: 0;

                    .device_check_white {
                        width: 22px;
                        height: 22px;
                    }
                }

                .step_2_active {
                    color: #FFFFFF;
                }

                .step_1_active::before,
                .step_1_active::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    width: 0;
                    height: 0;
                    border-style: solid;
                }

                .step_1_active::before {
                    top: 0;
                    border-width: 0 30px 30px 0;
                    border-color: transparent #E6E6E6 transparent transparent;
                }

                .step_1_active::after {
                    bottom: 0;
                    border-width: 30px 30px 0 0;
                    border-color: transparent #E6E6E6 transparent transparent;
                }
            }

            .login_top_active {
                background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
            }

            .login_info {
                width: 605px;
                height: 376px;
                background: #F2F3F5;
                border-radius: 20px;

                .login_label {
                    font-weight: 500;
                    font-size: 18px;
                    color: #303030;
                }

                .login_form {
                    .form_label {
                        color: #303030;
                        width: 80px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 48px;
                background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
                border-radius: 30px;
                color: #FFFFFF;
                text-align: center;
                line-height: 48px;
            }

            .login_desc {
                font-size: 14px;
                color: #BFBFBF;
            }
        }
    }
}
</style>